import { BaseRequest, PagingRequest } from 'Services/base';
import {
  CreateCreditAllocationReqBody,
  CreateCreditAllocationResponse,
  ListCreditAllocationsResponse,
} from './interfaces';
import { getQueryParamsForListAPI } from 'Services/api';

const CREDIT_ALLOCATIONS_BASE_URL = '/paymentservice/v1/credit-allocations';

export class CreateCreditAllocationRequest extends BaseRequest<CreateCreditAllocationResponse> {
  constructor(
    payload: CreateCreditAllocationReqBody,
  ) {
    super( {
      method: 'POST',
      url: CREDIT_ALLOCATIONS_BASE_URL,
      responseType: 'json',
      data: payload,
    } );
  }
}

export class ListCreditAllocationsRequest extends BaseRequest<ListCreditAllocationsResponse> {
  constructor(
    paging: PagingRequest,
  ) {
    super( {
      method: 'GET',
      url: CREDIT_ALLOCATIONS_BASE_URL,
      responseType: 'json',
      params: getQueryParamsForListAPI( paging ),
    } );
  }
}

export class GetCreditAllocationRequest extends BaseRequest<CreateCreditAllocationResponse> {
  constructor(
    code: string,
  ) {
    super( {
      method: 'GET',
      url: `${CREDIT_ALLOCATIONS_BASE_URL}/${code}`,
      responseType: 'json',
    } );
  }
}
